import React, { useEffect } from 'react';
import { Stack, Button } from '@mui/material';
import { BrowserSettingsCard } from '../assessment_instructions_modal/BrowserSettingsCard';

interface EnableCamMicModalProps {
  setModalContent: (content: number) => void;
}

export const EnableCamMicModal: React.FC<EnableCamMicModalProps> = ({
  setModalContent,
}) => {
  useEffect(() => {
    let stream: MediaStream | null = null;
    let isMounted = true;

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((mediaStream) => {
        if (isMounted) {
          stream = mediaStream;
          localStorage.setItem('permissions', 'granted');
        } else {
          // Component unmounted before stream was obtained, stop it immediately
          mediaStream.getTracks().forEach((track) => {
            track.stop();
          });
        }
      })
      .catch((error) => {
        console.error(
          '❌ EnableCamMicModal: Error accessing media devices:',
          error,
        );
      });

    // Cleanup: Stop all tracks when component unmounts
    return () => {
      isMounted = false;
      if (stream) {
        stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    };
  }, []);

  return (
    <Stack spacing={3} alignItems='flex-end' sx={{ width: '100%' }}>
      <BrowserSettingsCard />
      <Button
        variant='contained'
        color='primary'
        onClick={() => setModalContent(3)}
      >
        Next
      </Button>
    </Stack>
  );
};
